import {
    Component,
    OnInit,
    ViewEncapsulation,
    AfterViewInit,
    Output,
    EventEmitter
} from '@angular/core';
import { Helpers } from '../../../helpers';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../../../_services/data.service';
import { Paths, Roles } from '../../../models/enums';
import { Role } from '../../../models/role';

declare let mLayout: any;
@Component({
    selector: 'app-header-nav',
    templateUrl: './header-nav.component.html',
    encapsulation: ViewEncapsulation.None
})
export class HeaderNavComponent implements OnInit, AfterViewInit {
    isOwner: boolean;
    path: string;
    profile: any;
    roles: string[];
    isAdmin: boolean = false;
    isReadOnlyUser: boolean = false;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private dataService: DataService
    ) {
        this.path = this.dataService.path;
        if (this.dataService.path == Paths.Owner) this.isOwner = true;
    }
    ngOnInit() {

        this.dataService.profile.subscribe(user => {
            this.profile = user;
            this.setRoleInfo();
        });
    }
    ngAfterViewInit() {
        mLayout.initHeader();
    }

    logout() {
        this.router.navigate([this.path, 'logout']);
    }
    private setRoleInfo() {
        this.roles = this.dataService.roles;
        this.isAdmin = this.roles.includes(Roles.Admin.toString());
        this.isReadOnlyUser = this.roles.includes(Roles.ReadOnlyUser.toString());

    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/layouts/header-nav/header-nav.component.ts